export enum ContentType {
    EMPTY = 'EMPTY',
    CONTAINER = 'CONTAINER',
    CUSTOM = 'CUSTOM',
    DECORATION = 'DECORATION',
    NOTIFICATION = 'NOTIFICATION',
    GRAPH = 'GRAPH',
    DATA_TABLE = 'DATA_TABLE',
    HEATMAP = 'HEATMAP',
    ROADMAP = 'ROADMAP',
}